import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionsV2Service } from '../../../../../services/collectionsV2.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  selector: 'app-override-slots-config',
  templateUrl: './override-slots-config.component.html',
  styleUrls: ['./override-slots-config.component.scss'],
})
export class OverrideSlotsConfigComponent implements OnInit {
  @Input() data;
  @Input() linkedPartners;
  @Input() configuredSlots;
  @Input() vehicles;
  @Input() areas;
  @Input() isWorkshop : boolean = true;
  @Input() isRentals : boolean = false;
  @Output() close = new EventEmitter();
  public saving = false;
  public selectedVehicles: any = [];
  public selectedAreas: any = [];
  public minDate = new Date();
  public countryData: any = {};

  constructor(
    private collectionsService: CollectionsV2Service,
    private helpersService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    console.log(this.data);
    this.countryData = this.helpersService.getCountryData();
    console.log(this.countryData);
    if (this.data.linkedVehicles) {
      this.selectedVehicles = this.data.linkedVehicles.map((x) => {
        return x.deliveryVehicleID.toString();
      });
    }
    if (this.data.linkedAreas) {
      this.selectedAreas = this.data.linkedAreas.map((x) => {
        return x.areaID.toString();
      });
    }
  }

  valid() {
    return (
      this.data.date &&
      this.data.cutOffTime &&
      this.data.slotStartTime &&
      this.data.slotEndTime &&
      this.data.slotEndTime > this.data.slotStartTime &&
      this.selectedVehicles &&
      this.selectedVehicles.length > 0 &&
      this.selectedAreas &&
      this.selectedAreas.length > 0 &&
      (this.data.bufferDays === 0 &&
      this.data.cutOffTime >= this.data.slotStartTime
        ? false
        : true)
    );
  }

  save() {
    this.saving = true;
    var request = JSON.parse(JSON.stringify(this.data));
    request.date = moment(this.data.date).format('YYYY-MM-DD');
    request.slotStartTime = moment(this.data.slotStartTime).format('HH:mm:ss');
    request.slotEndTime = moment(this.data.slotEndTime).format('HH:mm:ss');
    request.cutOffTime = moment(this.data.cutOffTime).format('HH:mm:ss');
    request.linkedVehicles = this.selectedVehicles.map((x) => {
      return { deliveryVehicleID: x };
    });
    request.linkedAreas = this.selectedAreas.map((x) => {
      return { areaID: x };
    });
    request.workshopLinked = this.isWorkshop;
    request.rentalsLinked = this.isRentals;

    if (request.id) {
      this.collectionsService.updateOverrideSlot(request).subscribe(
        (res) => {
          this.saving = false;
          this.close.emit('');
        },
        (err) => {
          this.saving = false;
        },
      );
    } else {
      this.collectionsService
        .addOverrideSlot(this.helpersService.getPartnerId(), request)
        .subscribe(
          (res) => {
            this.saving = false;
            this.close.emit('');
          },
          (err) => {
            this.saving = false;
          },
        );
    }
  }

  formatCutOffTime(val) {
    return moment(val).format('h:mm A');
  }

  formatDate(val) {
    return moment(val).format(this.countryData.MomentDateFormat);
  }

  getBufferDate(buffer) {
    return moment(this.data.date)
      .add(-1 * buffer, 'day')
      .format(this.countryData.MomentDateFormat);
  }

  clearAreas(vehicle, val) {
    if (!val) {
      vehicle.linkedAreas.map((x) => {
        if (this.selectedAreas.indexOf(x.areaID.toString()) > -1) {
          this.selectedAreas.splice(
            this.selectedAreas.indexOf(x.areaID.toString()),
            1,
          );
        }
      });
      this.selectedAreas = JSON.parse(JSON.stringify(this.selectedAreas));
    }
  }

  canAreaBeSelected(area) {
    var allowedAreas = [];
    this.vehicles
      .filter((x) => {
        return this.selectedVehicles.includes(x.id.toString());
      })
      .map((x) => {
        return x.linkedAreas.map((y) => {
          allowedAreas.push(y.areaID);
        });
      });
    return allowedAreas.indexOf(area.id) > -1;
  }
}
